<div class="container-fluid ps-0 pe-0">
  <div class="row">
    <div class="col-12">
      <strong>Your selected and uploaded files</strong>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <div class="datatable-accordion mat-elevation-z2">
        <div class="table-responsive">
          <table class="table table-striped table-fixed table-hover table-sm mb-0">
            <thead class="table-header">
            <tr>
              <th></th>
              <th>Filename</th>
              <th>Type</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let file of selectedFiles">
              <td style="width: 10%;"><mat-checkbox (click)="removeFile(file)" [(ngModel)]="checked"></mat-checkbox></td>
              <td>{{file.name}}</td>
              <td>{{file.typeCode}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
